// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".theme--light.v-tabs-items[data-v-b3bcf5d2]{background-color:transparent!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
